// external link warning////
$(document).ready(function () {
  const currentHost = window.location.hostname.replace("www.", "");
  const warningText =
    " Redirecting to a third-party website (opens in a new tab).";

  $('a[href^="http://"], a[href^="https://"]').each(function () {
    const $link = $(this);
    const linkHost = this.hostname.replace("www.", "");

    if (linkHost === currentHost || !linkHost) return;

    let linkText = $link.text().trim();
    if (!linkText) {
      const imgAlt = $link.find("img").attr("alt");
      linkText = imgAlt ? imgAlt.trim() : "this link";
    }

    const currentAriaLabel = $link.attr("aria-label");
    const newLabel = currentAriaLabel
      ? `${currentAriaLabel}${warningText}`
      : `${linkText}${warningText}`;

    $link.attr({
      "aria-label": newLabel,
      title: newLabel,
      target: "_blank",
      rel: "noopener noreferrer nofollow",
    });

    $link.addClass("external-link");
  });
});

// make plain-text emails and phone numbers in collection descriptions clickable//

$(document).ready(function () {
  const contactPattern =
    /([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})|(?<![\d.])((?:\+?1[\s.-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]\d{4})(?!\d)/gi;

  function linkifyTextNode(node) {
    const text = node.nodeValue;
    contactPattern.lastIndex = 0;
    if (!contactPattern.test(text)) return;
    contactPattern.lastIndex = 0;

    const $fragment = $(document.createDocumentFragment());
    let lastIndex = 0;
    let match;

    while ((match = contactPattern.exec(text))) {
      const value = match[0];
      $fragment.append(document.createTextNode(text.slice(lastIndex, match.index)));

      let href;
      if (match[1]) {
        href = "mailto:" + value;
      } else {
        const digits = value.replace(/\D/g, "");
        href = "tel:" + (digits.length === 10 ? "+1" + digits : "+" + digits);
      }
      $fragment.append($("<a>", { href: href, text: value }));
      lastIndex = match.index + value.length;
    }

    $fragment.append(document.createTextNode(text.slice(lastIndex)));
    $(node).replaceWith($fragment.contents());
  }

  function linkifyContent($root) {
    $root.contents().each(function () {
      if (this.nodeType === 3) {
        linkifyTextNode(this);
      } else if (this.nodeType === 1 && !$(this).is("a, button, script, style, textarea, select, input")) {
        linkifyContent($(this));
      }
    });
  }

  $(".collection-description").each(function () {
    linkifyContent($(this));
  });
});

// email address for cms//
$(document).ready(function () {
  $('a[href^="mailto:"]').each(function () {
    if (!$(this).attr("aria-label")) {
      const emailText = $(this).text().trim();
      $(this).attr("aria-label", "Email address " + emailText);
    }
  });
});

// phone number for cms//
$(document).ready(function () {
  $('a[href^="tel:"]').each(function () {
    if (!$(this).attr("aria-label")) {
      const phoneText = $(this).text().trim();
      $(this).attr("aria-label", "phone number " + phoneText);
    }
  });
});

$(document).ready(function () {
  $("br").attr("aria-hidden", "true");
});

// accessible home slideshow: play/pause, keyboard and screen reader support//
$(document).ready(function () {
  const PAUSE_LABEL = "Pause automatic slide show";
  const PLAY_LABEL = "Play automatic slide show";
  const PAUSE_ICON =
    '<svg aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>';
  const PLAY_ICON =
    '<svg aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13a1 1 0 0 0 1.5.86l10.5-6.5a1 1 0 0 0 0-1.72L9.5 4.64A1 1 0 0 0 8 5.5z"/></svg>';
  const CONTROL_SELECTOR = ".previous-slide, .next-slide, .slideshow-pagination > span";
  const reduceMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function getCarousel(view) {
    return view && view.el ? $(view.el).find(".home-slideshow").first() : $();
  }

  function isStopped($carousel) {
    return $carousel.attr("data-a11y-rotation") === "stopped";
  }

  // Keep hidden slides out of the tab order and away from screen readers,
  // and mark the dot for the slide on screen.
  function syncSlides($carousel, index) {
    $carousel.find(".slideshow-slide").each(function (i) {
      if (i === index) {
        $(this).removeAttr("inert aria-hidden");
      } else {
        $(this).attr({ inert: "", "aria-hidden": "true" });
      }
    });
    $carousel.find(".slideshow-pagination > span").each(function (i) {
      $(this).attr("aria-disabled", i === index ? "true" : "false");
    });
  }

  // Hook into the theme's SlideshowView so a stopped slideshow stays stopped.
  function patchSlideshowView() {
    const View = window.SlideshowView;
    if (!View || View.prototype.a11yPatched) return;
    const proto = View.prototype;
    const startLoop = proto.startLoop;
    const nextSlide = proto.nextSlide;
    const updateSlidePagination = proto.updateSlidePagination;
    proto.a11yPatched = true;

    proto.startLoop = function () {
      const $carousel = getCarousel(this);
      $carousel.data("a11yView", this);
      if (isStopped($carousel)) return;
      return startLoop.apply(this, arguments);
    };

    proto.nextSlide = function (e) {
      // Autoplay calls nextSlide() without an event.
      if (!e && isStopped(getCarousel(this))) {
        this.pauseLoop();
        return;
      }
      return nextSlide.apply(this, arguments);
    };

    proto.updateSlidePagination = function (index) {
      const result = updateSlidePagination.apply(this, arguments);
      const $carousel = getCarousel(this);
      $carousel.data("a11yView", this);
      syncSlides($carousel, index);
      if ($carousel.data("a11yUserNav")) {
        $carousel.data("a11yUserNav", false);
        announceSlide($carousel, index);
      }
      return result;
    };
  }

  // Read the new slide (position, image alt text and heading) after the user
  // presses Previous
  function announceSlide($carousel, index) {
    const $announcer = $carousel.find(".slideshow-announcer");
    const $slides = $carousel.find(".slideshow-slide");
    const $slide = $slides.eq(index);
    if (!$announcer.length || !$slide.length) return;

    const alt = ($slide.find(".slide-image img").attr("alt") || "").trim();
    const title = $slide.find(".slide-title").first().text().trim();

    let message = "Slide " + (index + 1) + " of " + $slides.length;
    if (alt) message += ": " + alt;
    if (title && title !== alt) message += ". " + title;

    $announcer.text("");
    clearTimeout($carousel.data("a11yAnnounceTimer"));
    $carousel.data(
      "a11yAnnounceTimer",
      setTimeout(function () {
        $announcer.text(message);
      }, 100)
    );
  }

  function findView($carousel) {
    let view = $carousel.data("a11yView");
    if (view) return view;
    try {
      $.each(window.theme.sections.instanceHandlers.slideshow.instances, function (id, instance) {
        if (instance && instance.el && $.contains(instance.el, $carousel[0])) {
          view = instance;
          return false;
        }
      });
    } catch (err) {}
    if (view) $carousel.data("a11yView", view);
    return view || null;
  }

  function setRotation($carousel, rotating) {
    const view = findView($carousel);

    $carousel.attr("data-a11y-rotation", rotating ? "rotating" : "stopped");
    // Slide changes are read by the .slideshow-announcer status message instead.
    $carousel.find(".slideshow-slides").attr("aria-live", "off");
    $carousel
      .find(".slideshow-rotation-toggle")
      .attr("aria-label", rotating ? PAUSE_LABEL : PLAY_LABEL)
      .html(rotating ? PAUSE_ICON : PLAY_ICON);

    if (!view) return;
    if (rotating) {
      if (view.delay && !$carousel.is(":hover")) view.startLoop();
    } else {
      view.pauseLoop();
    }
  }

  function initSlideshow($carousel) {
    if ($carousel.attr("data-a11y-ready") === "true") return;
    $carousel.attr("data-a11y-ready", "true");

    const $slides = $carousel.find(".slideshow-slide");
    const autoplay = parseInt($carousel.attr("data-slideshow-autoplay"), 10) || 0;
    const $slidesWrap = $carousel.find(".slideshow-slides").first();
    const activeIndex = $slides.index($slides.filter(".active"));
    syncSlides($carousel, activeIndex > -1 ? activeIndex : 0);

    // Hidden status message that screen readers read when the slide changes.
    $("<div>", {
      class: "slideshow-announcer visually-hidden",
      role: "status",
      "aria-live": "polite",
      "aria-atomic": "true",
    }).appendTo($carousel);

    // Mark slide changes the user asked for (mouse, Enter or Space), so only
    // those are announced. The theme's own click handler runs right after this.
    $carousel.on("click", CONTROL_SELECTOR, function () {
      $carousel.data("a11yUserNav", true);
      setTimeout(function () {
        $carousel.data("a11yUserNav", false);
      }, 0);
    });

    $carousel.on("keydown", '[role="button"]:not(button)', function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        this.click();
      } else if (e.key === " " || e.key === "Spacebar") {
        e.preventDefault();
      }
    });
    $carousel.on("keyup", '[role="button"]:not(button)', function (e) {
      if (e.key === " " || e.key === "Spacebar") {
        e.preventDefault();
        this.click();
      }
    });

    if (autoplay <= 0 || $slides.length < 2) {
      $carousel.attr("data-a11y-rotation", "stopped");
      return;
    }

    // Play/pause button, first in the slideshow's tab order.
    const $toggle = $("<button>", { type: "button", class: "slideshow-rotation-toggle" });
    if ($slidesWrap.attr("id")) $toggle.attr("aria-controls", $slidesWrap.attr("id"));
    $carousel.prepend($toggle);

    $toggle.on("click", function () {
      setRotation($carousel, isStopped($carousel));
    });

    // Stop rotating when keyboard focus moves into the slideshow.
    $carousel.on("focusin", function (e) {
      if (e.relatedTarget && $.contains($carousel[0], e.relatedTarget)) return;
      let keyboardFocus = true;
      try {
        keyboardFocus = $(e.target).is(":focus-visible");
      } catch (err) {}
      if (keyboardFocus && !isStopped($carousel)) setRotation($carousel, false);
    });

    setRotation($carousel, !reduceMotion);
  }

  function initAll(root) {
    $(root || document)
      .find(".home-slideshow")
      .each(function () {
        initSlideshow($(this));
      });
  }

  patchSlideshowView();
  initAll();

  // Theme editor re-renders sections.
  $(document).on("shopify:section:load", function (e) {
    initAll(e.target);
  });
});

// accessible header dropdown menus: expanded/collapsed state and focus//
$(document).ready(function () {
  const TRIGGER_SELECTOR = ".navigation .mega-nav > a, .navigation .has-dropdown > a";
  const OPEN_ITEM_SELECTOR = ".navigation .mega-nav.active, .navigation .has-dropdown.active";
  let navCount = 0;

  function getDropdown($item) {
    return $item.children("ul").first();
  }

  function getTrigger($item) {
    return $item.children("a").first();
  }

  function firstLink($dropdown) {
    return $dropdown
      .find("a[href], button, [tabindex]")
      .filter(function () {
        return this.tabIndex >= 0 && !$(this).closest('[aria-hidden="true"]').length && $(this).is(":visible");
      })
      .first();
  }

  function syncExpanded($item) {
    getTrigger($item).attr("aria-expanded", $item.hasClass("active") ? "true" : "false");
  }

  function closeItem($item) {
    $item.removeClass("active");
    syncExpanded($item);
  }

  function initMenus(root) {
    $(root || document)
      .find(TRIGGER_SELECTOR)
      .each(function () {
        const $trigger = $(this);
        const $item = $trigger.parent();
        const $dropdown = getDropdown($item);
        if (!$dropdown.length || $trigger.attr("data-a11y-menu") === "true") return;
        $trigger.attr("data-a11y-menu", "true");

        if (!$dropdown.attr("id")) $dropdown.attr("id", "NavDropdown-" + ++navCount);
        $trigger.attr("aria-controls", $dropdown.attr("id"));
        // "Shop" uses href="#": it only opens the menu, so it is a button.
        if ($trigger.attr("href") === "#") $trigger.attr("role", "button");
        syncExpanded($item);

  
        new MutationObserver(function () {
          syncExpanded($item);
        }).observe($item[0], { attributes: true, attributeFilter: ["class"] });


        $item.on("focusout", function (e) {
          if (e.relatedTarget && !$.contains($item[0], e.relatedTarget) && $item.hasClass("active")) {
            closeItem($item);
          }
        });
      });
  }

  // After the theme's click handler opens a menu, move focus into it.
  $(document).on("click", TRIGGER_SELECTOR, function () {
    const $trigger = $(this);
    if ($trigger.attr("data-a11y-menu") !== "true") return;
    const $item = $trigger.parent();
    setTimeout(function () {
      syncExpanded($item);
      if (!$item.hasClass("active")) return;
      firstLink(getDropdown($item)).trigger("focus");
    }, 0);
  });

  $(document).on("keydown", function (e) {
    const $target = $(e.target);


    if (e.key === " " || e.key === "Spacebar") {
      if ($target.is(TRIGGER_SELECTOR) && $target.attr("role") === "button") {
        e.preventDefault();
        e.target.click();
      }
      return;
    }

    // Escape closes the open menu and returns focus to its trigger.
    if (e.key === "Escape" || e.key === "Esc") {
      const $openItem = $target.closest(OPEN_ITEM_SELECTOR);
      if (!$openItem.length) return;
      const $trigger = getTrigger($openItem);
      closeItem($openItem);
      $trigger.trigger("focus");
    }
  });

  initMenus();

  $(document).on("shopify:section:load", function (e) {
    initMenus(e.target);
  });
});


// contact form: move focus to the error or success message after the form is sent//
$(document).ready(function () {
  const $status = $("#ContactFormErrors, #ContactFormSuccess").first();
  if ($status.length) $status.trigger("focus");
});

// mobile menu toggle: expanded/collapsed state (the theme toggles .active on the button)//
$(document).ready(function () {
  function initToggle(root) {
    $(root || document)
      .find(".mobile-navigation-toggle")
      .each(function () {
        const $toggle = $(this);
        if ($toggle.attr("data-a11y-toggle") === "true") return;
        $toggle.attr("data-a11y-toggle", "true");

        function sync() {
          $toggle.attr("aria-expanded", $toggle.hasClass("active") ? "true" : "false");
        }

        sync();
        new MutationObserver(sync).observe(this, { attributes: true, attributeFilter: ["class"] });
      });
  }

  initToggle();

  $(document).on("shopify:section:load", function (e) {
    initToggle(e.target);
  });
});

// mobile menu "+" tier toggles: expanded/collapsed state and the list they open (the theme toggles .open on the item)//
$(document).ready(function () {
  let tierCount = 0;

  function initTierToggles(root) {
    $(root || document)
      .find(".navigation .mobile-tier-toggle")
      .each(function () {
        const $toggle = $(this);
        if ($toggle.attr("data-a11y-tier") === "true") return;
        $toggle.attr("data-a11y-tier", "true");

        const $item = $toggle.parent();
        const $list = $item.children("ul").first();
        if ($list.length) {
          if (!$list.attr("id")) $list.attr("id", "NavTier-" + ++tierCount);
          $toggle.attr("aria-controls", $list.attr("id"));
        }

        function sync() {
          $toggle.attr("aria-expanded", $item.hasClass("open") ? "true" : "false");
        }

        sync();
        new MutationObserver(sync).observe($item[0], { attributes: true, attributeFilter: ["class"] });
      });
  }

  initTierToggles();

  $(document).on("shopify:section:load", function (e) {
    initTierToggles(e.target);
  });
});

// mobile menu "Close menu" button (visually hidden, last item in the menu): closes the menu through the theme's own toggle and returns focus to the menu button//
$(document).ready(function () {
  $(document).on("click", ".mobile-navigation-close", function (e) {
    e.preventDefault();
    const toggle = document.querySelector(".mobile-navigation-toggle");
    if (!toggle) return;
    if ($(".navigation").hasClass("mobile-visible")) toggle.click(); 
    toggle.focus();
  });
});
